import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

//import c40v1a from './c40v1a';
import c40v1a from './c40v_20211024';

import cView from './cView';

export default class c41v extends cView { // 機能情報

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_c41rListsss: {c41r:[]},
  sdld_c41rDtlsss: {c41r:[]},
  s_c41rc31s: '',
};

static op_loadDtl = (pd) => 
  (pd.elm == 'c41r') ? 
    super.op_loadDtl({
      ...pd,
      dd_cldDefss: {
        c410: { // alias
          elm: 'c410',
          o_cnd: _dd_datss => {
//            let _cnd = cf.c('c410', ` c410b51k = ${_dd_datss.c41r.d_flds._key}`); // 歴管理への対応
            let _cnd = cf.c('c410', ` c410b51k = ${_dd_datss.c41r.d_flds._key}`, false, false); // 歴管理への対応
//ff.l('44: {}'.f(_cnd));
            return _cnd;
          },
          dd_rfrss: {
            c40r: {
              elm: 'c40r',
              o_cnd: _d_flds => {
//                let _cnd = cf.c('c40r', ` _key = ${_d_flds.c410b41k}`, true); // b_fnd == true
                let _cnd = cf.c('c40r', ` _key = ${_d_flds.c410b41k}`, true, false); // b_fnd == true
                return _cnd;
              },
            }
          },
          ld_sortss: [
            { fld: 'c40rc11s', dtn: 'asc', mode: 'nmb' }
          ],
        },
      },
    })
  : super.op_loadDtl(pd)
;

$clp_loadLists = () => [ // 親を上書き
  c41v.op_loadList({
    elm: 'c41r',
    o_cnd: _dd_datss => {
      let _cnd = cf.c('c41r', 'c41rc11s <> "999999999999"', false, true);
      return _cnd;
    },
  }),
];

$clp_loadDtls = () => [
  c41v.op_loadDtl({
    elm: 'c41r',
  }),
  c40v1a.op_loadSlcList({
    elm: 'c40r',
/*
    cnd: 
      global.t?.state.sgcd_stgs._00100100 != '10' ? // 決済を使用しない場合
        'c40rc11s <> "1080"'
      : null,
*/
  }),
  c41v.op_loadVsnList({ // 予約
    elm: `c41r`,
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_c41rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      c41r: {
        b_setPageKey: true,
        od_insDats: _dd_datss => {
          let _d = {
            c41rc11s: _dd_datss.c41r.d_flds.c41rc11s ?? '',
            c41rc31s: _dd_datss.c41r.d_flds.c41rc31s ?? '',
          };
          return _d;
        },
        dd_cldDefss: {
          c410: {
            elm: 'c410',
            b_setPageKey: false,
            od_insDats: _dd_datss => {
              let _d = {
                c410b41k: _dd_datss.c410.d_flds.c410b41k ?? -1,
                c410b51k: global.t?.state.sgc_pageKey ?? -1,
              };
              return _d;
            },
          },
        },

      },
    },

  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        pfx:
          (global.t?.state.sgc_pnlMode == 'list') ?
            '権限分類一覧・登録'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            '権限分類詳細・変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            '権限分類詳細・変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            '権限分類新規登録'
          : null,
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -1,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_bdys: {
              d_msgBfrs: {
                pfx: `【権限分類の確認・変更】･･･IDを押すと詳細画面に移動し、変更もその画面で行えます。`,
                n_mgnTop: ic.s(1),
                d_stlCtas: {
                  minWidth: ic.gn_bdyW,
                },
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_c41rListsss',
                    dd_elmDefss: {
                      c41r: {
                        elm: 'c41r',
                        b_row: true,
                        b_rootHdr: true,
                        b_ttl: false,
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c41rc11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                          cf.f('c41rc31s', {
                            d_hdrs: { n_w: ic.s(20)  },
                            d_bdys: { n_w: ic.s(20) },
                          }),
                        ]),
                      },
                    },
                  }),
                ])                

              ],
            },
            d_btms: {
/*
              d_news: {
                elm: 'c41r',
                state: 'sdld_c41rDtlsss',
                d_insFlds: {
                  ...cf.e('c41r').d_insFlds, 
                },
                dld_cldDatsss: {
                  'c410': {
                    elm: 'c410',
                    d_insFlds: {
                      ...cf.e('c410').d_insFlds, 
                    },
                  },
                },
              },
*/
              l_clds: [
                ce.c(ce.Box, {
                  key: -2,
                  stlCta: {
                    minHeight: ic.s(2 * 2),
                    width: ic.gn_minBdyW,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginTop: ic.s(0.5), // 20211202
                    marginBottom: ic.s(0.5), // 20211202
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -20,
                    pfx: '前の画面に戻る',
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                    o_onPrs: () => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.t?.state.sgc_pageRole,
                        sgc_pageName: 'iStg1',
                        sgc_pageMode: 'show',
                      }; 
                      cf.myRN_move_fwd(_d_pageInfs);
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -10,
                    pfx: '権限分類の新規登録',
                    b_rvs: false,
                    stlBtn: {
                      width: ic.s(12),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        elm: 'c41r',
                        state: 'sdld_c41rDtlsss',
                        d_insFlds: {
                          ...cf.e('c41r').d_insFlds, 
                        },
                        dld_cldDatsss: {
                          'c410': {
                            elm: 'c410',
                            d_insFlds: {
                              ...cf.e('c410').d_insFlds, 
                            },
                          },
                        },
                        mode: 'sttNew',
                        b_clr: true, // 現行要素の初期化に必要
                      })
                    },
                  }),
                ])
              ],
            },
          }),

          ce.c(ce.Pnl, {
            key: -2,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_hdrs: {
              d_htys: {
                elm: 'c41r',
                ld_iss: global.t?.state.sdld_c41rVsnListsss?.c41r,
                op_loadDtl: c41v.op_loadDtl,
              },
            },
            d_btms: {
            },
            d_bdys: {
              d_stlCtas: {
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_c41rDtlsss',
                    dd_elmDefss: {
                      c41r: {
                        elm: 'c41r',
//                        b_row: true,
//                        b_rootHdr: true,
//                        b_ttl: false,
                        b_row: false,
                        b_rootHdr: false,
                        b_ttl: true,
/*
                        d_btns: {
                          d_clds:{
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                            pfx: '機能を追加'
                          },
                        },
*/                         
                          d_cmns: {
                            n_cnt: 1,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c41rc11s', {
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                          cf.f('c41rc31s', {
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                        ]),
                        dd_cldDefss: {
                          c410: {
                            elm: 'c410',
                            d_insFlds: cf.e('c410').d_insFlds, 
                          },
                        },
                      },
                    },
                  }),                
                ]),

                ce.c(ce.Box, {
                  key: -20,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -2,
                    state: 'sdld_c41rDtlsss',
                    dd_elmDefss: {
                      c41r: {
                        elm: 'c41r',
                        dd_cldDefss: {
                          c410: {
                            elm: 'c410',
                            b_row: true,
                            b_subHdr: true,
                            b_ttl: false,
                            d_insFlds: cf.e('c410').d_insFlds, 
                            d_btns: {
                              d_btrs:{
                                b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                                pfx: '機能を追加'
                              },
                              d_dlts: {
                                b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                                pfx: '',
                              },
                            },
                            dd_fldDefss: cf.myRN_getFldDefs([
                              cf.f('c410b41k', {
                                ld_iss: global.t?.state.sdld_c40rSlcListsss?.c40r,
                                d_hdrs: { n_w: ic.s(15)  },
                                d_bdys: { n_w: ic.s(15) },
                              }),
                            ]),
                            d_stlSubBdyCtas: {
                              borderWidth: 0,
                              borderTopWidth: ic.gn_bdrWNrw,
                              borderBottomWidth: ic.gn_bdrWNrw,
                              borderColor: ic.o_getCcd('d'),
                            },
                          },
                        },
                      },
                    },
                  }),                
                ]),

              ],
            },
            d_btms: {
            },
          }),

        ],
      }
    })
  );
}

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
